"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrapAlert = require("react-bootstrap/Alert");

var _reactBootstrapAlert2 = _interopRequireDefault(_reactBootstrapAlert);

var PropTypes = _react2["default"].PropTypes;

exports["default"] = _react2["default"].createClass({
  displayName: "Alert",

  /**
   * React properties
   */

  propTypes: {
    // Type of alert to display.
    bsStyle: PropTypes.oneOf(["warning", "danger", "success", "info"]),

    // If we have a child, it's the message we need to display in the alert.
    // Otherwise, we display no alert.
    children: PropTypes.node,

    // If true, the alert will not displayed again if it was hidden and its
    // properties were changed.
    noReset: PropTypes.bool,

    // Callback when the alert is closed.
    onHide: PropTypes.func,

    // Whether the alert message can be closed (dismissed) or not.
    permanent: PropTypes.bool
  },

  /**
   * React lifecycle
   */

  getDefaultProps: function getDefaultProps() {
    return {
      // Display an "info" alert.
      bsStyle: "info",

      // Allow the message to be dismissed.
      permanent: false
    };
  },

  getInitialState: function getInitialState() {
    return {
      // Whether the alert message is displayed or not.
      display: true
    };
  },

  componentWillReceiveProps: function componentWillReceiveProps() {
    if (!this.props.noReset) {
      this.setState({ display: true });
    }
  },

  /**
   * Own methods
   */

  /**
   * Hides the alert.
   */
  hide: function hide() {
    var _this = this;

    this.setState({ display: false }, function () {
      if (_this.props.onHide) {
        _this.props.onHide();
      }
    });
  },

  /**
   * React render
   */

  render: function render() {
    // Message to display.
    var message = this.props.children;

    // Bootstrap style to use.
    var bsStyle = this.props.bsStyle;

    // Display the Bootstrap alert if necessary.
    if (this.state.display && message) {
      return _react2["default"].createElement(
        _reactBootstrapAlert2["default"],

        // Uses the same style as Bootstrap to define the alert style.
        { bsStyle: bsStyle,

          // React-Bootstrap will only display a close button if the onDismiss
          // event handler property is defined.
          onDismiss: !this.props.permanent ? this.hide : undefined
        },
        message
      );
    }

    // If we're not displaying the alert, return an empty node.
    return null;
  }
});
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/react-bootstrap-components/lib/Alert.js
// module id = 2128
// module chunks = 6